<template>
	<div class="tab-body">
		<div class="search">
			<el-form ref="form" :model="searchParams" label-width="80px">
				<el-row>
					<el-col :span="6">
						<el-form-item label="名称">
							<el-input placeholder="团队名称、产品名称、成员姓名" v-model="searchParams.name"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="开始时间">
							<el-date-picker v-model="searchParams.stm" value-format="yyyy-MM-dd"
								format="yyyy-MM-dd" type="date" placeholder="选择日期">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="结束时间">
							<el-date-picker v-model="searchParams.etm" value-format="yyyy-MM-dd"
								format="yyyy-MM-dd" type="date" placeholder="选择日期">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<div class="search-btn">
						<el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
						<el-button @click="clearSearchVal">清空</el-button>
					</div>
				</el-row>
			</el-form>
		</div>

		<div class="operator">
			<el-button size="mini" v-has-permission-code-and="'003000050005'" type="primary" icon="el-icon-plus"
				@click="toSave()">添加</el-button>
		</div>

		<!-- 二级表格 -->
		<div class="dataTable autoFlex" v-if="listData">
			<el-table class="table" :data="listData.records" stripe border height="auto"
				:span-method="objectSpanMethod" @selection-change="selectionChange" v-loading="listLoading">
				<el-table-column prop="name" width="160" label="团队名称"></el-table-column>

				<el-table-column prop="members" width="300" label="成员">
					<template slot-scope="scope">
						<el-tag v-for="v in scope.row.emps" size="mini"
							:type="v.post == 'SM' ? 'danger' : (v.post == 'PO' ? 'primary' : 'success')">
							{{ v.nm }} ({{ v.post }})
						</el-tag>
					</template>
				</el-table-column>

				<el-table-column prop="pname" width="200" label="产品"></el-table-column>

				<el-table-column label=" Sprint名称 / 周期">
					<template slot-scope="scope">
						{{ scope.row.snm }}
						<el-tag size="mini" type="success"> {{ scope.row.stm }} </el-tag>
						~ <el-tag size="mini" type="danger"> {{ scope.row.endtm }}
						</el-tag>

					</template>
				</el-table-column>
				<el-table-column fixed="right" width="260">
					<template slot-scope="scope">
						<div class="dataTable-operator">
							<template>
								<el-button size="mini" v-has-permission-code-and="'003000050000'"
									@click="toDetail(scope.$index, scope.row)">详情</el-button>
								<el-button size="mini" v-has-permission-code-and="'003000050005'"
									@click="toUpdate(scope.$index, scope.row)">编辑</el-button>
								<el-button size="mini" v-has-permission-code-and="'003000050010'"
									type="danger"
									@click="remove(scope.$index, scope.row)">删除</el-button>
							</template>

						</div>
					</template>
				</el-table-column>


			</el-table>
			<div class="pageBar">
				<el-pagination @size-change="sizeChange" @current-change="currentChange" :total="listData.total"
					:page-size="page.size" :current-page="page.current" :layout="this.$constant.page.layout"
					:page-sizes="this.$constant.page.pageSizes"></el-pagination>
			</div>
		</div>
		<show ref="show"></show>
		<add ref="add"></add>
		<edit ref="edit"></edit>
	</div>
</template>
<script>
import add from './add.vue';
import edit from './edit.vue';
import show from './show.vue';
import api from '@/api/team/team/team.js';
import selectOptionDictionary from '@/components/biz/selectOptionDictionary/selectOptionDictionary.vue';



export default {
	name: 'team',

	components: {
		show,
		selectOptionDictionary,
		add, edit

	},
	data() {
		return {
			searchParams: {},
			isShowMoreSearch: false,
			listLoading: false,
			listData: [],
			selected: [],
			page: new this.$constant.pageObj(),
			tempNameList: [],
			tempNameSelected: [],
		};
	},
	methods: {

		//获取数据
		list() {
			this.listLoading = true;
			let params = this.$utils.merger(this.searchParams, this.page);
			api.list(params, response => {
				this.listData = response.data;
				//console.log("列表数据", this.listData);
				this.listLoading = false;
			},);
		},
		//去添加
		toSave() {
			this.$refs.add.open({}, '添加团队22');
		},
		//去编辑
		toUpdate(index, row) {

			let data = this.listData.records[index]

			console.log("去编辑 row", row);

			if (row.sid) {

			} else {
				row.tid = data.id;
				
			}
			row.teamname = data.name;
			row.pname = data.pname;
			//console.log("团队id" + this.listData.records[index].id);

			//取得
			if (data.sprints) {
				//1.自己row  有sprint
				this.$refs.edit.open(row, '编辑团队' ,row.id);

			} else {

				let teamArrs = this.listData.records.filter(v => (v.name == data.name))
				console.log("teamArrs", teamArrs)
				if (teamArrs.length == 1) {
					//2.没有兄弟team  不传tid
					this.$refs.edit.open(row, '编辑团队',row.id);
				} else {
					//3.有兄弟team    取有sprintID的团队的tid
					let hasSpintIDTeams = teamArrs.filter(v => (v.sprints))
					if (hasSpintIDTeams.length > 0) {
						this.$refs.edit.open(row, '编辑团队',  row.id);
					} else {
						//兄弟team也没有分配过Sprint
						this.$refs.edit.open(row, '编辑团队',row.id);
					}

				}
			}

		},
		//去详情
		toDetail(index, row) {
			console.log("row", row);
			console.log("选中的团队名称", this.listData.records[index].name);

			if (row.sid) {

			} else {
				row.tid = this.listData.records[index].id;
				console.log("row1111111", row);
			}
			row.snm = this.listData.records[index].snm;
			row.teamname = this.listData.records[index].name;
			row.pname = this.listData.records[index].pname;

			this.$refs.show.open(row, '团队sprint详情');
		},

		//删除
		remove(index, row) {

			console.log("index", index)

			let parameter = {
				tid: this.listData.records[index].id
			}
			this.$utils.confirm.warning('提示', '确定删除团队吗？', () => {
				api.removeByTid(
					parameter,
					response => {
						this.$utils.msg.success(response.msg);
						this.list();
					},
					response => {
						this.$utils.msg.warning(response.msg);
					}
				);
			});
			
		},
		//批量删除
		batchRemove() {
			if (!this.selected || this.selected.length == 0) {
				this.$utils.msg.info('请选择至少一行');
				return;
			}
			let parameter = {
				ids: this.selected
			};
			this.$utils.confirm.warning('提示', '确定删除吗？', () => {
				api.remove({
					ids: this.selected
				},
					response => {
						this.$utils.msg.success(response.msg);
						this.list();
					},
					response => {
						this.$utils.msg.warning(response.msg);
					}
				);
			});
		},
		//改变选择项
		selectionChange(val) {
			//清空
			this.selected = [];
			for (let item of val) {
				this.selected.push(item.id);
			}
		},
		//改变每页显示数量
		sizeChange(val) {
			this.page.size = val;
			this.list();
		},
		//改变现在的页码
		currentChange(val) {
			this.page.current = val;
			this.list();
		},

		//搜索
		search() {
			this.list();
		},
		//清空搜索框
		clearSearchVal() {
			this.searchParams = {};
			this.list();
		},
		//合并相同的名称的数据
		objectSpanMethod({ row, column, rowIndex, columnIndex }) {
			//console.log('objectSpanMethod', row, column, rowIndex, columnIndex)
			if (columnIndex === 0) { // 要合并列的下标 从0开始 如果合并第3列 写columnIndex===2
				const _row = this.flitterData(this.listData.records).one[rowIndex]
				const _col = _row > 0 ? 1 : 0
				return {
					rowspan: _row,
					colspan: _col
				}
			}
		},
		flitterData(arr) {
			// 合并表格第一列
			const spanOneArr = []
			let concatOne = 0
			arr.forEach((item, index) => {
				if (index === 0) {
					spanOneArr.push(1)
				} else {
					// console.log('item', item, index)
					// console.log('arr', arr[index - 1])
					// 这里的type_test是表格绑定的字段，也就是需要合并的字段，根据自己的需求来改
					if (item.name == arr[index - 1].name) {
						// 第一列需合并相同内容的判断条件
						spanOneArr[concatOne] += 1
						spanOneArr.push(0)
					} else {
						spanOneArr.push(1)
						concatOne = index
					}
				}
			})
			return {
				one: spanOneArr
			}
		}
	},
	mounted() {
		this.list();
	}
};
</script>

<style lang="scss" scoped="scoped">
@import '~common/custom/css/common.scss';
</style>
